// extracted by mini-css-extract-plugin
export var center = "_61-2";
export var clickableRow = "_61-5";
export var expandedRow = "_61-7";
export var hoverable = "_61-4";
export var left = "_61-1";
export var right = "_61-3";
export var row = "_61-0";
export var selectedRow = "_61-6";
export var summaryRow = "_61-8";